import VueRouter, { RouteConfig } from 'vue-router'

const QuizList = () => import('@/views/classroom-quiz/QuizList.vue')
const QuizCreate = () => import('@/views/classroom-quiz/QuizCreate.vue')
const QuizDetail = () => import('@/views/classroom-quiz/QuizDetail.vue')
const QuizDetailEdit = () => import('@/views/classroom-quiz/EditQuziDetail.vue')

const listRoute: RouteConfig = {
  path: '/classroom-quiz-list',
  name: 'classroom_quiz_list',
  component: QuizList,
  meta: {
    title: '测试列表',
  },
}

const createQuizRoute: RouteConfig = {
  path: '/classroom-quiz-create',
  name: 'classroom_quiz_create',
  component: QuizCreate,
  meta: {
    title: '选择班级',
  },
}

const quizDetailRoute: RouteConfig = {
  path: '/classroom-quiz-detail',
  name: 'classroom_quiz_detail',
  component: QuizDetail,
  meta: {
    title: '随堂测试',
  },
}

const quizDetailEditRoute: RouteConfig = {
  path: '/classroom-quiz-detail-edit',
  name: 'classroom_quiz_detail_edit',
  component: QuizDetailEdit,
  meta: {
    title: '随堂测试',
  },
}

export default [listRoute, createQuizRoute, quizDetailRoute, quizDetailEditRoute]

export function navigateToClassroomTest(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToCreateQuiz(router: VueRouter) {
  router.push({ name: createQuizRoute.name })
}

export function navigateToQuizDetail(router: VueRouter) {
  router.push({ name: quizDetailRoute.name })
}

export function navigateToQuizDetailEdit(router: VueRouter) {
  router.push({ name: quizDetailEditRoute.name })
}
